import { StyleSheet } from "@react-pdf/renderer";

export const styles = StyleSheet.create({

    header: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    borderBox: {
        position: 'absolute',
        top: 15,
        left: 15,
        right: 15,
        bottom: 15,
        border: '1 solid #ccc',
        borderRadius: 6,
        zIndex: -1
    },

    dashboardImage: {
        marginLeft: 'auto',
        marginRight: 'auto',
        width: '95%',
        maxHeight: '720px',  
     },
    logo: {
        width: 60,
        height: 60
    },
    topic: {
        fontSize: 18,
        fontWeight: 'bold',
        color: '#007f66',
    },
    title: {
        fontSize: 16,
        fontWeight: 'bold',
        color: '#007f66',
        fontStyle: 'italic',
        marginRight: 15
    },
    footer: {
        position: 'absolute',
        bottom: 15,
        left: 15,
        right: 15,
        fontSize: 10,
        color: '#fff',
        backgroundColor: '#0D9276',
        padding: 8,
        textAlign: 'center',
        borderRadius: 4
    },


});
  export  const glassyCardStyle = {
        background: 'white',
        backdropFilter: 'blur(15px)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        borderRadius: '16px',
        boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px"
    };
